import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
} from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { ReactComponent as Logo } from '../assets/FullLogo.svg';

function MenuBar({ isLandingPage }) {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (open) => {
    setOpen(open);
  };

  return (
    <AppBar
      position={'fixed'}
      sx={{
        backgroundColor: isLandingPage ? 'rgba(218, 210, 210, 0.85)' : '#ffffff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        zIndex: isLandingPage ? 10 : 1000,
        height: '110px',
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          px: 2,
          alignItems: 'center',
        }}
      >
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <Logo
          style={{
            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))',
            width: '350px',
            height: 'auto',

          }}
          />
        </Box>

        <IconButton
          edge="end"
          onClick={() => toggleDrawer(true)}
          sx={{ color: '#3e3e3e', mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer anchor="right" open={open} onClose={() => toggleDrawer(false)}>
        <List
          sx={{
            width: 250,
            backgroundColor: ' transparent',
            p: 2,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {[
            { text: 'Home', path: '/' },
            { text: 'Filter Tool', path: '/projects' },
            { text: 'Contact', path: '/contact' },
            { text: 'About', path: '/about' },
            { text: 'Help', path: '/help' },
          ].map((item) => (
            <ListItem
              button
              key={item.text}
              component={Link}
              to={item.path}
              onClick={() => toggleDrawer(false)}
              sx={{
                color: '#4b6043',
                fontSize: '1.2rem',
                py: 1.5,
                textTransform: 'capitalize',
                '&:hover': {
                  backgroundColor: '#c4b7a6',
                  color: 'white',
                },
              }}
            >
              <ListItemText
                primary={item.text}
                slotProps={{
                  fontFamily: 'General Sans, san-serif',
                  fontSize: '1.2rem',
                }}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
}

export default MenuBar;
